 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-04625c44":"118e54b8","chunk-0c7482f0":"83106ea0","chunk-10b80c62":"30a7466a","chunk-1341de8c":"b751a2b8","chunk-13c728d4":"a9166ead","chunk-1479f9a1":"a0d35c4d","chunk-16ffec50":"6f158d65","chunk-2306ece6":"a1c73dbf","chunk-248dd191":"30610a45","chunk-24a6ec22":"0835d7fa","chunk-1d66eb58":"7169bef5","chunk-1fc270ca":"b6542a8e","chunk-3806a4c9":"3acf79a8","chunk-c5354f5a":"96409501","chunk-3bff9cbd":"14e05961","chunk-5584b330":"7da18101","chunk-5e1ffd1b":"36a76a96","chunk-60cf4c39":"bce74cae","chunk-27aa150c":"cb40d006","chunk-2899ee32":"3075e50d","chunk-2d0aeedd":"771f9199","chunk-2d0c9b18":"dbd694ea","chunk-2d0cbe80":"a746e75b","chunk-2d0f1138":"a7ad035d","chunk-2d20efc5":"9e639650","chunk-2d67b44b":"d578b6e1","chunk-331e2748":"6a21ee14","chunk-375cc45e":"287721eb","chunk-39b1ba0c":"c55d7fad","chunk-2d0e62ba":"a2e4cfcf","chunk-2d22fd53":"b1547eff","chunk-3a7fce25":"400e89b5","chunk-40b61994":"d7f9e83d","chunk-4230c313":"6e43eb0d","chunk-45e9aef7":"8e175b3b","chunk-19c43a6d":"076142e6","chunk-9091a05a":"3bc10f50","chunk-2d0b93e8":"5afac0a3","chunk-2d0e4830":"41c325c3","chunk-54c7a6f9":"e1bc3c68","chunk-5a0ee522":"e05c558e","chunk-5a8111fb":"9a9c0020","chunk-5bd014c4":"ef645bf4","chunk-5dd1daca":"e84402ed","chunk-67c44154":"d4abe8c4","chunk-73eed4f7":"63f1bae0","chunk-748bf56c":"4dd88a50","chunk-7c047c44":"21fa92f8","chunk-81b0284e":"1b7c40d4","chunk-88e8cb1e":"ffed311f","chunk-912bf098":"59d72004","chunk-a8a3400c":"cda87256","chunk-b138c758":"c54378bb","chunk-dd0de2c6":"f895176a","chunk-e557591e":"d221169d","chunk-fb35eb86":"aa1bf79a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2306ece6":1,"chunk-1d66eb58":1,"chunk-1fc270ca":1,"chunk-3806a4c9":1,"chunk-c5354f5a":1,"chunk-60cf4c39":1,"chunk-5dd1daca":1,"chunk-912bf098":1,"chunk-dd0de2c6":1,"chunk-fb35eb86":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-04625c44":"31d6cfe0","chunk-0c7482f0":"31d6cfe0","chunk-10b80c62":"31d6cfe0","chunk-1341de8c":"31d6cfe0","chunk-13c728d4":"31d6cfe0","chunk-1479f9a1":"31d6cfe0","chunk-16ffec50":"31d6cfe0","chunk-2306ece6":"0c34f330","chunk-248dd191":"31d6cfe0","chunk-24a6ec22":"31d6cfe0","chunk-1d66eb58":"9e46b965","chunk-1fc270ca":"bdfdf49d","chunk-3806a4c9":"34ae05a9","chunk-c5354f5a":"34ae05a9","chunk-3bff9cbd":"31d6cfe0","chunk-5584b330":"31d6cfe0","chunk-5e1ffd1b":"31d6cfe0","chunk-60cf4c39":"bdfdf49d","chunk-27aa150c":"31d6cfe0","chunk-2899ee32":"31d6cfe0","chunk-2d0aeedd":"31d6cfe0","chunk-2d0c9b18":"31d6cfe0","chunk-2d0cbe80":"31d6cfe0","chunk-2d0f1138":"31d6cfe0","chunk-2d20efc5":"31d6cfe0","chunk-2d67b44b":"31d6cfe0","chunk-331e2748":"31d6cfe0","chunk-375cc45e":"31d6cfe0","chunk-39b1ba0c":"31d6cfe0","chunk-2d0e62ba":"31d6cfe0","chunk-2d22fd53":"31d6cfe0","chunk-3a7fce25":"31d6cfe0","chunk-40b61994":"31d6cfe0","chunk-4230c313":"31d6cfe0","chunk-45e9aef7":"31d6cfe0","chunk-19c43a6d":"31d6cfe0","chunk-9091a05a":"31d6cfe0","chunk-2d0b93e8":"31d6cfe0","chunk-2d0e4830":"31d6cfe0","chunk-54c7a6f9":"31d6cfe0","chunk-5a0ee522":"31d6cfe0","chunk-5a8111fb":"31d6cfe0","chunk-5bd014c4":"31d6cfe0","chunk-5dd1daca":"e935173d","chunk-67c44154":"31d6cfe0","chunk-73eed4f7":"31d6cfe0","chunk-748bf56c":"31d6cfe0","chunk-7c047c44":"31d6cfe0","chunk-81b0284e":"31d6cfe0","chunk-88e8cb1e":"31d6cfe0","chunk-912bf098":"7bdbe480","chunk-a8a3400c":"31d6cfe0","chunk-b138c758":"31d6cfe0","chunk-dd0de2c6":"4fd35474","chunk-e557591e":"31d6cfe0","chunk-fb35eb86":"3be1eb5f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sigemig/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
